module.exports = __webpack_public_path__ + "img/se.1cf04c85.svg";